import { DropdownMenu } from '@/components/ui/DropdownMenu';
import { IconChevron } from '@/components/ui/Icon';
import { useBranchMenu } from './useBranchMenu';

// Topbar pill that lets the user pick the active branch (see useBranchMenu).
// Hidden when the company has fewer than 2 active branches — there's nothing
// to pick. On phones the same choices sit in the Settings menu.
export function BranchPicker() {
  const { visible, label, title, items } = useBranchMenu();
  if (!visible) return null;
  return (
    <DropdownMenu
      align="right"
      label={`Branch: ${label}`}
      items={items}
      className="hidden md:inline-block"
      trigger={
        <div
          className="inline-flex items-center gap-1 bg-surface text-primary-text font-medium hover:bg-slate-50 transition cursor-pointer"
          style={{ padding: '2px 10px', borderRadius: '10px', border: '1px solid var(--border)', fontSize: '11px' }}
          title={title}
        >
          <span className="text-muted text-[0.625rem] uppercase tracking-wider">Branch</span>
          <span className="font-numeric">{label}</span>
          <IconChevron size={10} />
        </div>
      }
    />
  );
}
